import styles from './ProgressBar.module.css';

interface Props {
  /** 0-100, clamped */
  percent: number;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function ProgressBar({ percent, color, size = 'sm' }: Props) {
  const clamped = Math.max(0, Math.min(100, percent));
  const trackClass =
    size === 'lg'
      ? `${styles.track} ${styles.thick}`
      : size === 'md'
        ? `${styles.track} ${styles.chunkier}`
        : styles.track;
  return (
    <div className={trackClass}>
      <div
        className={styles.fill}
        style={{ width: `${clamped}%`, background: color ?? 'var(--accent)' }}
      />
    </div>
  );
}
